import React, { useState } from 'react';
import { 
  IoMailOutline, 
  IoFlashOutline, 
  IoConstructOutline, 
  IoBulbOutline, 
  IoTrophyOutline,
  IoSendOutline,
  IoCheckmarkCircleOutline,
  IoCloseCircleOutline,
  IoGameControllerOutline
} from 'react-icons/io5';
import './Contact.css';

const Contact = () => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus('');

    try {
      // Simulate sending email (you can integrate with your backend later)
      await new Promise(resolve => setTimeout(resolve, 1500));
      setStatus('success');
      setForm({ name: '', email: '', subject: '', message: '' });
    } catch (error) {
      setStatus('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page">
      <div className="contact-container">
        <div className="contact-header">
          <h1><IoMailOutline className="page-header-icon" /> Contact Us</h1>
          <p>Get in touch with the AI Game Show team. We'd love to hear from you!</p>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <h3><IoGameControllerOutline className="section-icon" /> Get Connected</h3>
            <div className="info-item">
              <IoFlashOutline className="info-icon" />
              <div>
                <h4>Quick Response</h4>
                <p>We typically respond within 24 hours</p>
              </div>
            </div>
            <div className="info-item">
              <IoConstructOutline className="info-icon" />
              <div>
                <h4>Technical Support</h4>
                <p>Need help with game mechanics or technical issues?</p>
              </div>
            </div>
            <div className="info-item">
              <IoBulbOutline className="info-icon" />
              <div>
                <h4>Suggestions</h4>
                <p>Have ideas for new features or improvements?</p>
              </div>
            </div>
            <div className="info-item">
              <IoTrophyOutline className="info-icon" />
              <div>
                <h4>Partnership</h4>
                <p>Interested in collaborating or sponsoring?</p>
              </div>
            </div>
          </div>

          <div className="contact-form-container">
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label>Full Name</label>
                <input
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  placeholder="Your full name"
                  required
                  disabled={loading}
                />
              </div>

              <div className="form-group">
                <label>Email Address</label>
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  placeholder="your.email@example.com"
                  required
                  disabled={loading}
                />
              </div>

              <div className="form-group">
                <label>Subject</label>
                <select
                  name="subject"
                  value={form.subject}
                  onChange={handleChange}
                  required
                  disabled={loading}
                >
                  <option value="">Select a subject</option>
                  <option value="technical-support">Technical Support</option>
                  <option value="game-feedback">Game Feedback</option>
                  <option value="feature-request">Feature Request</option>
                  <option value="partnership">Partnership Inquiry</option>
                  <option value="bug-report">Bug Report</option>
                  <option value="other">Other</option>
                </select>
              </div>

              <div className="form-group">
                <label>Message</label>
                <textarea
                  name="message"
                  value={form.message}
                  onChange={handleChange}
                  placeholder="Tell us more about your inquiry..."
                  rows="6"
                  required
                  disabled={loading}
                />
              </div>

              <button type="submit" className="submit-btn" disabled={loading}>
                <IoSendOutline className="btn-icon" />
                {loading ? 'Sending...' : 'Send Message'}
              </button>
            </form>

            {status === 'success' && (
              <div className="status-message success">
                <IoCheckmarkCircleOutline className="status-icon" />
                Message sent successfully! We'll get back to you soon.
              </div>
            )}

            {status === 'error' && (
              <div className="status-message error">
                <IoCloseCircleOutline className="status-icon" />
                Failed to send message. Please try again or email us directly.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;